import React from 'react';
import s from '../FeatureSection.scss';
import { Collapse } from '../../../../Collapse/Collapse';
import { FeatureSectionContext } from '../FeatureSection';
import { Box } from '@wix/design-system';
export const FeatureSectionContent = ({ dataHook, children, }) => {
    const { isOpen } = React.useContext(FeatureSectionContext);
    return (React.createElement(Collapse, { isOpened: isOpen, dataHook: dataHook },
        React.createElement(Box, { className: s.sectionSubgrid }, children)));
};
//# sourceMappingURL=FeatureSectionContent.js.map